import { render, staticRenderFns } from "./LayoutPanel.vue?vue&type=template&id=33b1190f&scoped=true"
import script from "./LayoutPanel.vue?vue&type=script&lang=js"
export * from "./LayoutPanel.vue?vue&type=script&lang=js"
import style0 from "./LayoutPanel.vue?vue&type=style&index=0&id=33b1190f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b1190f",
  null
  
)

export default component.exports